<template>
  <div class="wrapper elements">
    <div class="level-header elements-header">
      <div class="level__counter">6.</div>
      <div class="level__title elements__title">
        АРХИТЕКТУРНЫЕ
        ЭЛЕМЕНТЫ
      </div>
    </div>

    <div class="elements-task elements-zone dropArea">
      <div class="explain-wrapper elements-explain-area">
        <div class="explain elements-explain octa">
          <div class="explain__title">Восьмерик</div>
          <div class="explain__desc">Часть здания, имеющая в плане восьмигранную форму.
            Восьмигранный сруб.
          </div>
          <div class="explain-line">
            <svg width="298" height="328" viewBox="0 0 298 328" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M136.485 0.999023L137.382 0.557289L137.107 -0.000976562H136.485V0.999023ZM296.103 327.441C296.347 327.936 296.946 328.14 297.442 327.896C297.937 327.652 298.141 327.053 297.897 326.557L296.103 327.441ZM0.5 1.99902H136.485V-0.000976562H0.5V1.99902ZM135.588 1.44076L296.103 327.441L297.897 326.557L137.382 0.557289L135.588 1.44076Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain elements-explain quadr">
          <div class="explain__title">Четверик</div>
          <div class="explain__desc">
            Сруб, имеющий в плане квадратную или прямоугольную форму
          </div>
          <div class="explain-line">
            <svg width="292" height="217" viewBox="0 0 292 217" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M149.502 0.999023L150.338 0.449271L150.041 -0.000976562H149.502V0.999023ZM290.165 216.549C290.468 217.01 291.088 217.138 291.55 216.834C292.011 216.531 292.139 215.911 291.835 215.449L290.165 216.549ZM0 1.99902H149.502V-0.000976562H0L0 1.99902ZM148.667 1.54878L290.165 216.549L291.835 215.449L150.338 0.449271L148.667 1.54878Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain elements-explain marquee">
          <div class="explain__title">Шатёр</div>
          <div class="explain__desc">
            Шатровый верх, шатровое покрытие — высокое остроконечное завершение строения в виде
            четырех- или восьмигранной пирамиды.
          </div>
          <div class="explain-line">
            <svg width="150" height="281" viewBox="0 0 150 281" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M128 1.05078V0.0507812H127.356L127.089 0.637419L128 1.05078ZM0.684526 279.086C0.456232 279.589 0.678838 280.181 1.18173 280.41C1.68462 280.638 2.27737 280.415 2.50566 279.912L0.684526 279.086ZM149.899 0.0507812H128V2.05078H149.899V0.0507812ZM127.089 0.637419L0.684526 279.086L2.50566 279.912L128.911 1.46414L127.089 0.637419Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain elements-explain barrel">
          <div class="explain__title">Бочка</div>
          <div class="explain__desc">
            Декоративная форма двускатной кровли, оба ската которой имеют плавные криволинейные
            очертания и сходятся вверху под острым углом.
          </div>
          <div class="explain-line">
            <svg width="113" height="102" viewBox="0 0 113 102" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M74.2474 1.6709V0.670898H73.744L73.4441 1.07523L74.2474 1.6709ZM0.264823 99.7543C-0.064155 100.198 0.0287745 100.824 0.472387 101.153C0.915999 101.482 1.54231 101.389 1.87129 100.946L0.264823 99.7543ZM112.412 0.670898H74.2474V2.6709H112.412V0.670898ZM73.4441 1.07523L0.264823 99.7543L1.87129 100.946L75.0506 2.26657L73.4441 1.07523Z" fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain elements-explain glaucus">
          <div class="explain__title">Главка</div>
          <div class="explain__desc">
            Завершение кровли храма, имеющее форму луковицы, шлема. Состоит из журавцов, кружал,
            оси, досок обшивки. Покрывается лемехом.
          </div>
          <div class="explain-line">
            <svg width="202" height="76" viewBox="0 0 202 76" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M113 1.91406V0.914062H113.36L113.637 1.14308L113 1.91406ZM201.157 73.4374C201.583 73.7892 201.643 74.4195 201.291 74.8453C200.94 75.2711 200.309 75.3311 199.884 74.9794L201.157 73.4374ZM0 0.914062H113V2.91406H0V0.914062ZM113.637 1.14308L201.157 73.4374L199.884 74.9794L112.363 2.68505L113.637 1.14308Z"
                fill="black"/>
            </svg>
          </div>
        </div>
        <div class="explain elements-explain felling">
          <div class="explain__title">Повал</div>
          <div class="explain__desc">
            Плавное расширение верхней части сруба сразу под кровлей. Наружные выпуски брёвен
            образуют подобие карниза и придают конструкции дугообразный силуэт. Служит основанием
            для шатровых и скатных крыш, создавая навес над стенами и защищая их от влаги.
          </div>
          <div class="explain-line">
            <svg width="95" height="220" viewBox="0 0 95 220" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M75.8465 1.73828V0.738281H75.1307L74.8999 1.41584L75.8465 1.73828ZM1.02253 218.299C0.844448 218.822 1.12389 219.39 1.64668 219.568C2.16946 219.746 2.73763 219.466 2.91571 218.944L1.02253 218.299ZM94.3158 0.738281H75.8465V2.73828H94.3158V0.738281ZM74.8999 1.41584L1.02253 218.299L2.91571 218.944L76.7931 2.06072L74.8999 1.41584Z"
                fill="black"/>
            </svg>
          </div>
        </div>
      </div>
      <div v-for="task in tasks"
           :key="task.id"
           :class="task"
           :data-compare="task"
           class="elements__drop dropzone">
        <div class="queryMark">
          ?
        </div>
      </div>
    </div>
    <div class="elements-answers dropzone draggable-dropzone--occupied dragArea">
      <div v-for="answer in answers"
           v-bind:key="answer.name"
           :class="[answer.name]"
           :data-compare="answer.name"
           :hasPoint="answer.hasPoint"
           class="answer isDraggable">
        <div>
          <div class="answer__name">
            {{ answer.caption }}
          </div>
        </div>

      </div>
    </div>
    <div class="task-block">
      <div class="task-block__title">
        Расставьте правильно архитектурные элементы на церкви
      </div>
      <div class="task-block__caption">
        Перетащите мышью каждый элемент на картинку здания в соответствующие слоты
      </div>
    </div>
    <transition name="fade"
                :duration="400">
      <div class="finished-wrapper"
           v-if="levelFinished">
        <div class="finished__caption">Отлично!</div>
        <button v-if="levelFinished"
                @click="$emit('next-level', 'node')"
                class="levelControl next-level">
          продолжить
        </button>
      </div>
    </transition>
    <footer class="footer">
      <div class="footer__logo">
        <img src="../img/kizhi_logo.png" alt="">
      </div>
      <div class="footer__copyright">
        © 2019 Государственный историко-архитектурный и этнографический музей-заповедник «Кижи»
      </div>
    </footer>
    <!--Core components-->
    <level-core :tasks="tasks"
                :answers="answers"
                :explanation="'explain'"
                :answerOffset="[-3, 35]"
                @level-finished="onLevelFinished"
                @calculate-points="$emit('calculate-points', $event)"
    ></level-core>
  </div>
</template>

<script>
    /* eslint-disable indent */

    import {Droppable} from '@shopify/draggable';
    import levelCore from './level-сore.vue';

    export default {
        components: {
            levelCore,
        },
        data() {
            return {
                levelPoints: 0,
                levelFinished: false,
                tasks: ['octa', 'quadr', 'marquee', 'barrel', 'glaucus', 'felling'],
                answers: [
                    {name: 'octa', caption: 'Восьмерик', hasPoint: true},
                    {name: 'quadr', caption: 'Четверик', hasPoint: true},
                    {name: 'marquee', caption: 'Шатёр', hasPoint: true},
                    {name: 'barrel', caption: 'Бочка', hasPoint: true},
                    {name: 'glaucus', caption: 'Главка', hasPoint: true},
                    {name: 'felling', caption: 'Повал', hasPoint: true},
                ],
            };
        },
        methods: {
            onLevelFinished(result) {
                this.levelFinished = result;
            },
        },
        watch: {},
        computed: {},
        updated() {
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>


При сборке не обошлось без сложностей. Болты не качественные, и быстро срывается резьба. Но если не торопиться и закручивать болты по диагонали с обоих сторон,
или собирать его в двоем, то будет легче. Газлифт не самый качественный, через полгода начинает поскрипывать,
но в целом за свою цену работает отлично, главное вовремя смазывать.
Механизм покачивания отличный. Колесики спустя почти год отлично ездят, не застревают. Подлокотники хоть и кажутся большими, но на деле отлично подходят под стандартный стол.
